import { useWSModal } from "@wingspanhq/fe-component-library";
import { ModalUploadWorkLogAttachment } from "./index";

export const useModalUploadWorkLogAttachment = () =>
  useWSModal(ModalUploadWorkLogAttachment, {
    title: "Add attachment",
    size: "M"
  });
